export interface FooterTheme {
  wrapper: string
  container: string
  text: {
    base: string
  }
  link: string
}

export const footer = {
  wrapper: 'w-full py-6 mt-8 border-t border-cyan-500/20',
  container: 'container mx-auto px-4',
  text: {
    base: 'text-center text-sm text-cyan-400/70'
  },
  link: 'text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400 hover:opacity-80 transition-all duration-300'
} 